<template>
	<i class="wind-icon" :class="classes" :style="iconStyle" @click="onIconClick"></i>
</template>
<script>
/**
 * Icon by shang 2020/2/25
 * @desc Icon 图标
 * @params [String] type 内置样式
 * {arrow-down:下箭头,arrow-up:上箭头,arrow-right:右箭头,search: 放大镜,search-clear:搜索框清除按钮, add:加号按钮}
 */
import ICON_URL from '../../js/config/icon_url'
export default {
	name: 'w-icon',
	props: {
		imgUrl: String,
		width: String,
		height: String,
		backgroundSize: String,
		margin: String,
		type: String,
		size: {
			type: String,
			default: 'normal'
		},
		stop: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		iconStyle () {
			const imgUrl = this.$fxUtils.isDef(this.type) ? ICON_URL[this.type] : this.imgUrl
			return {
				width: this.width,
				height: this.height,
				backgroundSize: this.backgroundSize,
				margin: this.margin,
				backgroundImage: `url(${imgUrl})`
			}
		},
		classes () {
			return [
				`wind-icon__size-${this.size}`
			]
		}
	},
	methods: {
		onIconClick (event) {
			if (this.stop) {
				event.stopPropagation()
			}
			this.$emit('click')
		}
	}
}
</script>
<style scoped>
.wind-icon {
	display: inline-block;
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	width: 20px;
	height: 20px;
}
.wind-icon__size-mini {
	width: 12px;
	height: 12px;
}
</style>



// WEBPACK FOOTER //
// index.vue?52f336e4